module.exports = __webpack_public_path__ + "img/bullseye.bf6267d.jpg";